module.exports = __webpack_public_path__ + "img/culture.7d435872.svg";